import moment from "moment-timezone";

// The window every custom-events fetch must ask for.
//
// The month grid draws whole weeks, so it shows days either side of the month itself. Asking only to
// endOf("month") leaves those spillover cells drawn but empty, and paging away is the only way to
// see what lives there.
//
// The end reaches six days past the month, so it covers the last grid row whatever day the
// person's week starts on.
//
// Use this everywhere. setCustomEvents REPLACES the store, so one narrower refetch elsewhere throws
// away the events another one loaded.
export const getCustomEventsWindow = ({ fromDate, toDate }) => ({
  start: moment(fromDate)
    .subtract(3, "months")
    .startOf("month")
    .startOf("isoWeek")
    .format("YYYY-MM-DD"),
  end: moment(toDate).endOf("month").add(6, "days").format("YYYY-MM-DD"),
});

export default { getCustomEventsWindow };
